/*
    Export di tutti gli endpoint per poterli richiamare anche da altri componenti
*/

export const Root = "/";
export const Login = "/login";
export const ResetPassword = "/resetpassword";

/**
 * Dashboard
 */

export const SingleDashboard = "/dashboard/:id";
export const SingleDashboardId = (id) => `/dashboard/${id}`;
export const ManageDashboard = "/managedashboard";

/**
 * Service and updates
 */
export const DeviceStatus = "/devicestatus";
export const DownloadLogs = "/downloadLogs";
export const UpdatesManagement = "/updatesManagement";
export const UpdatePackages = "/updatepackages";
export const ScheduleConfigurations = "/schedules";

/**
 * Predictive Maintenance
 */

export const PreventiveMaintenance = "/preventiveMaintenance";
export const PredictiveMaintenance = "/predictiveMaintenance";
export const LogAnalysis = "/logAnalysis";

/**
 * Remote link
 */
export const RemoteLink = "/remotelink";

/**
 * OTC
 */
export const SmartLock = "/smartlock";

/**
 * Cash Flow
 */
export const CashReport = "/cashreport";
export const CashContent = "/cashcontent";
export const CashWorkload = "/cashworkload";
export const BranchReport = "/branchreport";
export const UsersBalance = "/usersBalance";
export const ChannelsBalance = "/channelsBalance";
export const BagsCashReport = "/bagsCashReport";

/**
 * Security and configuration
 */
export const SecurityConfig = "/securityconfig";
export const StocksConfig = "/stocksconfig";
export const ReferenceConfig = "/referenceconfig";
export const CaosUserSync = "/caosusersync";
export const CaosConfig = "/caosconfiguration";
export const CaosTemplate = "/caostemplate";

/**
 * Fitness Statistics
 */
export const StatisticsReport = "/statisticsreport";
export const EcrCodes = "/ecrcodes";

/**
 * Tools
 */
export const LicensesManagement = "/licensesmanagement";
export const BranchesManagement = "/branchesManagement";
export const NetworkMetrics = "/networkMetrics";
export const UserManagement = "/manageusers";
export const UserEvents = "/userevents";
export const PlatformMaintenance = "/platformmaintenance";
export const OrganizationsManagement = "/organizationsManagement";
export const OrganizationsLicenses = "/organizationsLicenses";
export const OnBoarding = "/onBoarding";
export const DataFlowManagement = "/dataflowmanagement";

export const Options = "/options";
export const Information = "/info";
export const Debug = "/debug";
export const InstallationDetails = "/installationDetails/:installationName";
export const GetInstallationDetailsRoute = (installationName) => `/installationDetails/${installationName}`;
export const UserPreferences = "/userpreferences";
